import { ReactNode } from "react";

export interface DropdownOption {
  key: string;
  label: string;
  icon?: ReactNode;
  onClick: () => void;
  isActive?: boolean;
}

interface DropdownSelectorProps {
  triggerIcon: ReactNode;
  options: DropdownOption[];
  className?: string;
}

export function DropdownSelector({
  triggerIcon,
  options,
  className = "",
}: DropdownSelectorProps) {
  return (
    <div className="dropdown dropdown-end dropdown-hover">
      <button
        type="button"
        tabIndex={0}
        className={`btn btn-ghost btn-sm btn-circle ${className}`}
      >
        {triggerIcon}
      </button>
      <ul
        className={
          "dropdown-content menu z-[1] min-w-52 gap-1 rounded-box bg-neutral p-2 shadow"
        }
      >
        {options.map((option) => (
          <li key={option.key}>
            <button
              type="button"
              onClick={option.onClick}
              className={`flex items-center whitespace-nowrap ${option.isActive ? "bg-base-300" : ""}`}
            >
              {option.icon && <span className="mr-2">{option.icon}</span>}
              {option.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
